import axios from "axios";

const api_base_url = process.env.REACT_APP_API_BASEURL + "/OfficeAppliance";

export const getOfficeAppliances = async () => {
  return axios.get(`${api_base_url}`).then((res) => {
    return res.data;
  });
};

export const getOfficeApplianceBrand = async () => {
  return axios.get(`${api_base_url}/OfficeApplianceBrand`).then((res) => {
    return res.data;
  });
};

export const getOfficeApplianceType = async () => {
  return axios.get(`${api_base_url}/OfficeApplianceType`).then((res) => {
    return res.data;
  });
};

export const getRetailStoreOptions = async () => {
  return axios.get(`${api_base_url}/RetailStoreOptions`).then((res) => {
    return res.data;
  });
};

export const getFilteredOfficeAppliance = async (filterInputData) => {
  const [, filters] = filterInputData.queryKey;
  const queryStrings = new URLSearchParams();

  if (filters) {
    filters.officeId?.forEach((id) => queryStrings.append("OfficeId", id));
    filters.officeApplianceTypeId?.forEach((typeId) =>
      queryStrings.append("OfficeApplianceTypeId", typeId)
    );
    filters.officeApplianceBrandId?.forEach((brandId) =>
      queryStrings.append("OfficeApplianceBrandId", brandId)
    );
  }

  const filterParams = {
    params: queryStrings,
  };

  return axios
    .get(`${api_base_url}/FilteredOfficeAppliances`, filterParams)
    .then((res) => {
      return res.data;
    });
};

export const getOfficeApplianceByOfficeId = async (officeId) => {
  return await axios
    .get(`${api_base_url}/OfficeApplianceByOfficeId/${officeId}`)
    .then((res) => {
      return res.data;
    });
};

export const getOfficeApplianceById = async (applianceId) => {
  return await axios
    .get(`${api_base_url}/OfficeApplianceById/${applianceId}`)
    .then((res) => {
      return res.data;
    });
};

export const addOfficeAppliance = async (officeAppliance) => {
  return await axios.post(`${api_base_url}/`, {
    ...officeAppliance,
  });
};

export const updateOfficeAppliance = async (officeAppliance) => {
  return await axios.put(`${api_base_url}/`, {
    ...officeAppliance,
  });
};

export const deactivateOfficeApplianceById = async (officeApplianceIds) => {
  return await axios.put(
    `${api_base_url}/DeactivateOfficeAppliance`,
    officeApplianceIds
  );
};
